// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1vfVS","file":"styles_file__3OE86"};